(function () {
  // Mobile nav toggle
  var toggle = document.querySelector('[data-nav-toggle]');
  var nav = document.querySelector('[data-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', nav.classList.contains('is-open'));
    });
  }

  // Search overlay toggle
  var searchToggle = document.querySelector('[data-search-toggle]');
  var searchOverlay = document.querySelector('[data-search-overlay]');
  if (searchToggle && searchOverlay) {
    searchToggle.addEventListener('click', function () {
      searchOverlay.classList.toggle('is-open');
      var input = searchOverlay.querySelector('input[type="search"]');
      if (searchOverlay.classList.contains('is-open') && input) input.focus();
    });
  }

  // Product page: swap main image on thumbnail click
  document.querySelectorAll('[data-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var main = document.querySelector('[data-main-image]');
      if (main) { main.src = thumb.dataset.src; main.srcset = ''; }
    });
  });

  // Product page: variant selection updates price + hidden id
  var form = document.querySelector('[data-product-form]');
  if (form && window.BC_PRODUCT) {
    var product = window.BC_PRODUCT;
    var selects = form.querySelectorAll('[data-option-select]');
    var idInput = form.querySelector('input[name="id"]');
    var priceEl = document.querySelector('[data-product-price]');
    var button = form.querySelector('[type="submit"]');
    function money(cents) {
      return (window.BC_MONEY_FORMAT || '${{amount}}').replace(/\{\{\s*amount\s*\}\}/, (cents / 100).toFixed(2));
    }
    function update() {
      var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
      var match = product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === chosen[i]; });
      });
      if (!match) return;
      idInput.value = match.id;
      if (priceEl) priceEl.textContent = money(match.price);
      if (button) {
        button.disabled = !match.available;
        button.textContent = match.available ? (button.dataset.labelAdd || 'Add to bag') : (button.dataset.labelSoldOut || 'Sold out');
      }
    }
    selects.forEach(function (s) { s.addEventListener('change', update); });
    update();
  }

  // Add-to-bag via AJAX on product cards
  document.querySelectorAll('form[data-ajax-cart]').forEach(function (f) {
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = f.querySelector('[type="submit"]');
      var original = btn.textContent;
      btn.disabled = true; btn.textContent = 'Adding…';
      fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: f.querySelector('[name="id"]').value, quantity: 1 }] })
      }).then(function (r) { return r.json(); }).then(function () {
        return fetch('/cart.js').then(function (r) { return r.json(); });
      }).then(function (cart) {
        var count = document.querySelector('[data-cart-count]');
        if (count) count.textContent = cart.item_count;
        btn.textContent = 'Added ♥';
        setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1600);
      }).catch(function () {
        btn.textContent = original; btn.disabled = false;
        f.submit();
      });
    });
  });
})();
